import axios from "axios";

const instance = axios.create({
  baseURL: process.env.FB_CONFIG_API_URL,
});

export default instance;
